import { TempSavedValue, Applicant, RightHolder } from '../types';

export const isTempSavedValue = (value: unknown): value is TempSavedValue => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const tempValue = value as TempSavedValue;
  return (
    typeof tempValue['書類名'] === 'string' &&
    (tempValue['書類名'] === '自動納付申出書' || tempValue['書類名'] === '自動納付取下書') &&
    typeof tempValue['提出日'] === 'string' &&
    typeof tempValue['法域'] === 'string' &&
    (tempValue['法域'] === '特許' || tempValue['法域'] === '実用新案登録' || tempValue['法域'] === '意匠登録') &&
    Array.isArray(tempValue['登録番号']) &&
    tempValue['登録番号'].every((registrationNumber: unknown) => typeof registrationNumber === 'string') &&
    isApplicant(tempValue['申出人']) &&
    isAgency(tempValue['代理人']) &&
    Array.isArray(tempValue['権利者']) &&
    tempValue['権利者'].every(isRightHolder) &&
    typeof tempValue['特許料等に関する特記事項']['親項目'] === 'string' &&
    typeof tempValue['特許料等に関する特記事項']['子項目'] === 'string' &&
    typeof tempValue['その他'] === 'string'
  );
};

export const isTempSavedValueWithoutAgency = (value: unknown): value is TempSavedValue => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const tempValue = value as TempSavedValue;
  return (
    typeof tempValue['書類名'] === 'string' &&
    (tempValue['書類名'] === '自動納付申出書' || tempValue['書類名'] === '自動納付取下書') &&
    typeof tempValue['提出日'] === 'string' &&
    typeof tempValue['法域'] === 'string' &&
    (tempValue['法域'] === '特許' || tempValue['法域'] === '実用新案登録' || tempValue['法域'] === '意匠登録') &&
    Array.isArray(tempValue['登録番号']) &&
    tempValue['登録番号'].every((registrationNumber: unknown) => typeof registrationNumber === 'string') &&
    isApplicant(tempValue['申出人']) &&
    Array.isArray(tempValue['権利者']) &&
    tempValue['権利者'].every(isRightHolder) &&
    typeof tempValue['特許料等に関する特記事項']['親項目'] === 'string' &&
    typeof tempValue['特許料等に関する特記事項']['子項目'] === 'string' &&
    typeof tempValue['その他'] === 'string'
  );
};

const isApplicant = (value: unknown): value is Applicant => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const applicant = value as Applicant;
  return (
    typeof applicant['識別番号'] === 'string' &&
    typeof applicant['住所又は居所'] === 'string' &&
    typeof applicant['氏名又は名称'] === 'string' &&
    typeof applicant['代表者'] === 'string' &&
    typeof applicant['電話番号'] === 'string' &&
    typeof applicant['納付方法']['納付種別'] === 'string' &&
    typeof applicant['納付方法']['納付番号'] === 'string'
  );
};

const isAgency = (value: unknown): value is Applicant => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const applicant = value as Applicant;
  return (
    typeof applicant['識別番号'] === 'string' &&
    typeof applicant['住所又は居所'] === 'string' &&
    typeof applicant['氏名又は名称'] === 'string' &&
    typeof applicant['代表者'] === 'string' &&
    typeof applicant['電話番号'] === 'string'
  );
};

const isRightHolder = (value: unknown): value is RightHolder => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const agency = value as RightHolder;
  return (
    typeof agency['識別番号'] === 'string' &&
    typeof agency['住所又は居所'] === 'string' &&
    typeof agency['氏名又は名称'] === 'string'
  );
};
